<!--
  @component Navbar.MenuBar

  A component that represents the main navigation menu bar in the navbar.
  It wraps the NavbarGroup component and provides a container for navigation items.

  @prop role - The ARIA role for the menu bar (default: "menubar")
  @prop label - The accessible label for the menu bar (default: "Navigation")
  @prop as - The HTML element to render the menu bar as (default: "nav")
  @prop css - Custom CSS styles to apply to the menu bar
  @prop colorVariant - The color variant of the menu bar

  Example:
  <Navbar.MenuBar label="Main Navigation">
    <Navbar.Item label="Home" href="/" />
    <Navbar.Item label="Products" href="/products" />
    <Navbar.Item label="About" href="/about" />
  </Navbar.MenuBar>
-->

<script lang="ts">
  import NavbarGroup from '../components/navbar-group.svelte';
  import { css } from '@agapi/ui/panda/css';
  import { navbarStyles } from '../navbar.styles';
  import type { NavbarMenuBarProps } from '../navbar.types';

  /**
   * Props for the Navbar.MenuBar component.
   * @type {NavbarMenuBarProps}
   */
  const {children, role = "menubar", label = "Navigation", css: cssProp}: NavbarMenuBarProps = $props();

  /**
   * Styles for the Navbar.MenuBar component.
   * @type {Object}
   */
  const styles = navbarStyles.raw();
</script>

<NavbarGroup role={role} label={label} as="nav" css={css.raw(styles.menubar, cssProp)}>
  {#if children}
    {@render children()}
  {/if}
</NavbarGroup>